import { useShowUpgradeModalDialog } from 'Hooks/useGlobalDialogDispatchers'
import { Limits } from 'TypeDefs/FeatureGatingRule/FeatureGatingRule'
import { styled, Button, AlertTitle } from '@mui/material'
import { Alert } from '@resiliatech/birdsong'

type Props = {
  seats: Limits
  setOpen: (isOpen: boolean) => void
}

export const AddMembersAlert = ({ seats, setOpen }: Props) => {
  const hasUnlimitedInvites = seats.limit === null
  const alertText = hasUnlimitedInvites
    ? 'You have unlimited invites with your plan!'
    : `You have ${seats.available} invite${
        seats.available > 1 || seats.available === 0 ? 's' : ''
      } remaining with your plan`
  let severity: 'info' | 'warning' | 'error'

  if (hasUnlimitedInvites) {
    severity = 'info'
  } else if (seats.available > 0) {
    severity = 'warning'
  } else {
    severity = 'error'
  }

  const dispatchShowUpgradeModal = useShowUpgradeModalDialog()

  return (
    <TheAlert
      severity={severity}
      action={
        !hasUnlimitedInvites && (
          <Button
            color='inherit'
            size='small'
            onClick={() => {
              setOpen(false)
              dispatchShowUpgradeModal(true)
            }}
          >
            Upgrade
          </Button>
        )
      }
    >
      <AlertTitle sx={{ marginBottom: 0 }}>{alertText}</AlertTitle>
      We recommend inviting your entire team and board to the platform.
    </TheAlert>
  )
}

const TheAlert = styled(Alert)<{ severity: string }>`
  margin-bottom: 0px;
  background: ${(props) => {
    switch (props.severity) {
      case 'info':
        return '#E5F2FF'
      case 'warning':
        return '#FFF3C9'
      case 'error':
        return '#FFE7E7'
      default:
        return '#fff'
    }
  }};
`
